import { LockOutlined, UserOutlined } from "@ant-design/icons"
import { Button, Form, Input, message } from "antd"
import './index.css'
import { useNavigate } from "react-router-dom"
import { URL_IMG, URL_LOGIN, requestUrl } from "../Utils/UrlUtils"
import { useEffect, useState } from "react"
import LoginImg from '../../res/logo.png'
export default () => {
  const navigate = useNavigate()
  const [imgData, setImgData] = useState<any>()
  const [freshImg, setFreshImg] = useState<number>(0)
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState<boolean>(false)  //是否正在登录

  useEffect(() => {
    requestUrl({
      url: URL_IMG,
      method: 'GET',
      noToken: true,
      success: (data) => {
        setImgData(data)
      }
    })
  }, [freshImg])

  const onFinish = (values: any) => {
    // console.log('Received values of form: ', values);
    let body = {
      "phone": values.phone,
      // "phone":'1362546321',
      "pwd": values.password,
      // "pwd":'123',
      "code": values.code,
      "uuid": imgData.uuid,
    }
    setLoading(true)
    requestUrl({
      url: URL_LOGIN,
      method: 'POST',
      body: JSON.stringify(body),
      success: (data: any) => {
        sessionStorage.setItem('token', data.token)
        sessionStorage.setItem('userName', data.userName)
        sessionStorage.setItem('phone', data.phone)
        sessionStorage.setItem('unit', data.unit)
        messageApi.open({
          type: 'success',
          content: '登录成功'
        });
        navigate('/MainPage')
      },
      fail: (msg) => {
        messageApi.open({ type: 'error', content: msg });
        setFreshImg(freshImg + 1)
      },
      finally: () => {
        setLoading(false)
      }
    })
  };

  return (
    <>
      {contextHolder}
      <div style={{ width: '100vw', height: '100vh', backgroundColor: '#2E394B', justifyContent: 'center' }}>

        <div style={{
          display: 'flex', flexDirection: 'column', justifyContent: 'center',
          justifySelf: 'center', alignItems: 'center', paddingTop: '100px'
        }}>
          <img src={LoginImg} style={{ height: '80px', width: '80px' }} />
          <div style={{ fontSize: '25px', textAlign: 'center', color: 'white', fontWeight: 'bold', marginTop: '20px' }}>
            大连公路建设部行业文件汇编
          </div>
          <Form
            name="normal_login"
            className="login-form"
            initialValues={{ remember: true }}
            onFinish={onFinish}
          >
            <Form.Item
              style={{ height: '45px' }}
              name="phone"
              rules={[{ required: true, message: '请输入手机号码' }]}
            >
              <Input
                style={{ height: '37.5px' }}
                prefix={<UserOutlined className="site-form-item-icon" />}
                placeholder="手机号" />
            </Form.Item>
            <Form.Item
              style={{ height: '45px' }}
              name="password"
              rules={[{ required: true, message: '请输入密码' }]}
            >
              <Input
                style={{ height: '37.5px' }}
                prefix={<LockOutlined className="site-form-item-icon" />}
                type="password"
                placeholder="密码"
              />
            </Form.Item>

            {
              imgData ?
                <Form.Item
                  name="code"
                  style={{ height: '45px' }}
                  rules={[{ required: true, message: '请输入验证码' }]}
                >
                  <div style={{ display: 'flex' }}>
                    <img style={{ width: '50%' }} src={'data:image/jpg;base64,' + imgData.img} onClick={() => {
                      setFreshImg(freshImg + 1)
                      setImgData(undefined)
                    }} />
                    <Input
                      style={{ flex: '1', paddingLeft: '10px', marginLeft: '10px', height: '37.5px' }}
                      placeholder='验证码' />
                  </div>
                </Form.Item> :
                <></>
            }
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                className="login-form-button">
                {loading ? '正在登录' : '登录'}
              </Button>
            </Form.Item>
          </Form>
        </div>

      </div>
    </>
  )

}